/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-12-09 18:09:46
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-06-06 21:23:49
 */
const state = {
  kName: "",
  showTrajectory: false, // 是否显示轨迹
  palyBtnName: "start", // 轨迹播放状态名称
  trajectoryPlay: { workId: "", show: false }, // 轨迹播放信息
  machineCategoryId3: "", // 演示期间临时使用字段
  curMachine: {}, // 田间日演示设备信息
};
const mutations = {
  changeShowTrajectory(state, payload) {
    state.showTrajectory = payload;
  },
  changeBtnName(state, payload) {
    state.palyBtnName = payload;
  },
  changeTrajectoryPlay(state, payload) {
    state.trajectoryPlay = payload;
  },
  changeMachineCategoryId3(state, payload) {
    state.machineCategoryId3 = payload;
  },
  setCurMachine(state, payload) {
    state.curMachine = payload;
  },
};
const actions = {
  changeShowTrajectory({ commit }, data) {
    commit("changeShowTrajectory", data);
  },
  changeBtnName({ commit }, data) {
    commit("changeBtnName", data);
  },
  changeTrajectoryPlay({ commit }, data) {
    commit("changeTrajectoryPlay", data);
  },
  changeMachineCategoryId3({ commit }, data) {
    commit("changeMachineCategoryId3", data);
  },
  setCurMachine({ commit }, data) {
    commit("setCurMachine", data);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
